var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showPickUp
    ? _c("div", { staticClass: "preview__section pick-up" }, [
        _c("div", { staticClass: "preview__title" }, [
          _vm._v(
            "\n    " + _vm._s(_vm.translations.pickupPointTitle.text) + "\n  "
          ),
        ]),
        _vm.isPickUpOrMeet && _vm.isTravelServices
          ? _c("div", { staticClass: "preview__text" }, [
              _vm._v(_vm._s(_vm.translations.pickupExtra1.text)),
            ])
          : _vm._e(),
        _vm.hasOwnPickup
          ? _c("div", { staticClass: "preview__text" }, [
              _vm._v(_vm._s(_vm.translations.pickupExtra2.text)),
            ])
          : _vm._e(),
        _vm.pickUpDescription
          ? _c("div", { staticClass: "preview__text" }, [
              _vm._v(_vm._s(_vm.pickUpDescription)),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }